import { OptimusProvider, QueryBoundary } from '@mews-commander/ui';
import { Button, Stack } from '@optimus-web/core';
import { FloatingPanel } from '@mews/b2b-ui';
import { lt } from '@mews/framework';

interface LedgersExportPanelProps {
    title: React.ReactNode;
    children: React.ReactNode;
    onClose: () => void;
    submitButton: React.ReactElement;
}

export const LedgersExportPanel: React.FC<LedgersExportPanelProps> = ({ title, children, onClose, submitButton }) => (
    <FloatingPanel
        size="small"
        active
        onClose={onClose}
        title={title}
        footer={{
            primary: submitButton,
            secondary: (
                <Button data-test-id="cancel-button" onClick={onClose} type="button" variant="tertiary" size="medium">
                    {lt('Cancel')}
                </Button>
            ),
        }}
    >
        <QueryBoundary loader="inline">
            <OptimusProvider density="spacious">
                <Stack vertical spacing="400">
                    {children}
                </Stack>
            </OptimusProvider>
        </QueryBoundary>
    </FloatingPanel>
);
